import { css } from '@emotion/css';

export const fromInfo = css`
  margin: 4px 0;
  padding: 2px 4px;
  font-size: 12px;
  color: var(--ant-primary-color);
  background-color: var(--ant-primary-1);
  border-radius: 2px;
  text-wrap: nowrap;
  /* dark 下 antd 的 --ant-primary-1 被全局重映射为中性的 --fett-bg-active，
     这里跟随品牌主色：文字取主色 65% + 白调亮（生主色在暗底上偏暗），底色取主色 24% 透明叠加，
     color-mix 动态计算，品牌切换自动跟随，无需按品牌注册 token */
  [data-color-mode='dark'] & {
    color: color-mix(in srgb, var(--ant-primary-color) 65%, #fff);
    background-color: color-mix(in srgb, var(--ant-primary-color) 24%, transparent);
  }
`;

export const fromBtn = css`
  margin: 0 4px !important;
  padding: 2px 4px !important;
  font-size: 12px !important;
  color: var(--ant-primary-color) !important;
  background-color: var(--ant-primary-1) !important;
  border-radius: 2px !important;
  text-wrap: nowrap !important;
  height: 24px;
  /* dark 下跟随品牌主色（同上，文字 65% 主色调亮 + 24% 主色透明底） */
  [data-color-mode='dark'] & {
    color: color-mix(in srgb, var(--ant-primary-color) 65%, #fff) !important;
    background-color: color-mix(in srgb, var(--ant-primary-color) 24%, transparent) !important;
  }
`;
